/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import FormDialog from '../../../Components/Modal/modal';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import './kpiPerformanceCycle.scss';
import { MANAGE_KPI_DASHBOARD, CANCEL_TEXT, CONTINUE, SELECT, FETCH } from '../../../Constants/strings';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox, Typography } from '@mui/material';
import { ReactComponent as CustomCheckedIcon } from '../../../Assets/images/svg/dar_custom_check_icon_1.svg';
import {fetchKpiPerformanceCycleList} from './kpiPerformanceCycleUtil';


const KpiPerformanceCycle = ({
  modalOpen,
  handleClose,
}) => {
  const navigate = useNavigate();
  const [selectPerformancePeriod, setSelectPerformancePeriod] = useState(null);
  const [selectPreviousPerformance, setSelectPreviousPerformance] = useState(null);
  const [performancePeriodList, setPerformancePeriodList] = useState([]);
  const [kpiPerformancePeriodList, setKpiPerformancePeriodList] = useState([]);
  const [isPreviousPerformance, setIsPreviousPerformance] = useState(false);
  const [performanceError, setPerformanceError] = useState('');
  const [previousPerformanceError, setPreviousPerformanceError] = useState('');


  useEffect(() => {
    const fetchData = async () => {
      const { kpiSetList, nonKpiSetList } = await fetchKpiPerformanceCycleList();
      setKpiPerformancePeriodList(kpiSetList);
      setPerformancePeriodList(nonKpiSetList);
    };

    fetchData();
  }, []);


  const handleCloseWithReset = () => {
    setSelectPerformancePeriod(null);
    setIsPreviousPerformance(false);
    setSelectPreviousPerformance(null);
    setPerformanceError('');
    setPreviousPerformanceError('');
    handleClose();
  };

  const handlePerformancePeriodFilter = (event) => {
    setSelectPerformancePeriod(event.target.value);
    setPerformanceError('');
    localStorage.setItem('kpiPerformance', JSON.stringify(event.target.value));
  };

  const handlePreviousPerformanceFilter = (event) => {
    setSelectPreviousPerformance(event.target.value);
    setPreviousPerformanceError('');
    localStorage.setItem('kpiPreviousPerformance', JSON.stringify(event.target.value));
  };

  const handleContinueOrFetch = () => {
    let hasError = false;

    if (!selectPerformancePeriod) {
      setPerformanceError(MANAGE_KPI_DASHBOARD.REQUIRED_FILED);
      hasError = true;
    }

    if (isPreviousPerformance && !selectPreviousPerformance) {
      setPreviousPerformanceError(MANAGE_KPI_DASHBOARD.REQUIRED_FILED);
      hasError = true;
    }

    if (hasError) {
      return;
    }

    if (isPreviousPerformance) {
      navigate('/configuration/manage-kpi/set-kpi', { state: {showImage: isPreviousPerformance } });
    } else {
      navigate('/configuration/manage-kpi/set-kpi');
    }
  };

  const handleCheckboxChange = (event) => {
    setIsPreviousPerformance(event.target.checked);
  };

  // main ui component
  return (
    <div>
      <FormDialog
        title={MANAGE_KPI_DASHBOARD.SET_TARGET}
        open={modalOpen}
        button1Action={handleCloseWithReset}
        button2Action={handleContinueOrFetch}
        dialogPaperCss="select-performance-dialog-paper"
        dialogCss="select-performance-dialog"
        dialogBodycontent={
          <div className="select-performance-dialog-body">
            <div className="select-performance-dropdown">
              <SearchDropdown
                options={performancePeriodList}
                label={MANAGE_KPI_DASHBOARD.SELECT_FROM.PERFORMANCE_PERIOD}
                placeholder={SELECT}
                value={selectPerformancePeriod}
                onChange={handlePerformancePeriodFilter}
                id="performance-period-dropdown"
              />
              {performanceError && (
                <div className="kpi-performance-error">
                  <small>{performanceError}</small>
                </div>
              )}
            </div>
            <div className="previous-performance-checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    className={`core-checkbox ${selectPerformancePeriod ? 'selected' : ''}`}
                    checked={isPreviousPerformance}
                    onChange={handleCheckboxChange}
                    checkedIcon={<CustomCheckedIcon />}
                    disabled={!selectPerformancePeriod}
                  />
                }
                className="core-form-control-label"
                label={
                  <Typography className={`performance-typography ${selectPerformancePeriod ? 'selected' : ''}`}>
                    {MANAGE_KPI_DASHBOARD.SELECT_FROM.CHECKBOX_PREVIOUS}
                  </Typography>
                }
              />
            </div>
            {isPreviousPerformance
            && <div className="select-previous-performance-dropdown">
              <SearchDropdown
                options={kpiPerformancePeriodList}
                label={MANAGE_KPI_DASHBOARD.SELECT_FROM.PREVIOUS_PERFORMANCE}
                placeholder={SELECT}
                value={selectPreviousPerformance}
                onChange={handlePreviousPerformanceFilter}
                id="performance-period-dropdown"
              />
              {previousPerformanceError && (
                <div className="kpi-performance-error">
                  <small>{previousPerformanceError}</small>
                </div>
              )}
            </div>
            }
          </div>
        }
        button1={CANCEL_TEXT}
        button2={isPreviousPerformance ? FETCH : CONTINUE}
        cancelButtonId="select-performance-cancel-btn"
        submitButtonId="select-performance-submit-btn"
      />
    </div>
  );
};

KpiPerformanceCycle.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default KpiPerformanceCycle;
